import { createSelector } from 'reselect'

const sliceSelector = (state) => state.managedEventTypes.assign

const assignSelector = createSelector(sliceSelector, (slice) => slice)

export const eventTypeSelector = createSelector(assignSelector, (slice) => slice.eventType)

export const assignedUserGroupsCountSelector = createSelector(
  eventTypeSelector,
  ({ assigned_user_groups_count: assignedUserGroupsCount }) => assignedUserGroupsCount
)

const isManagedEventTypeLoadedSelector = createSelector(
  assignSelector,
  ({ status }) => status === 'loaded'
)

export const assignedPeopleCountSelector = createSelector(
  eventTypeSelector,
  isManagedEventTypeLoadedSelector,
  (
    {
      assigned_organization_memberships_count: assignedOrganizationMembershipsCount,
      assigned_organization_invitations_count: assignedOrganizationInvitationsCount,
    },
    isLoaded
  ) => {
    if (!isLoaded) {
      return ''
    }
    return assignedOrganizationMembershipsCount + assignedOrganizationInvitationsCount
  }
)

const assignPopupSelector = createSelector(
  assignSelector,
  ({ assignPopup }) => assignPopup
)

export const isAssignPopupOpenSelector = createSelector(
  assignPopupSelector,
  ({ isOpen }) => isOpen
)

export const assignPopupScopeSelector = createSelector(
  assignPopupSelector,
  ({ scope }) => scope
)

export const isAssignPopupSubmittingSelector = createSelector(
  assignPopupSelector,
  ({ submitting }) => submitting
)

export const assignPopupUserGroupIdSelector = createSelector(
  assignPopupSelector,
  ({ userGroupId }) => userGroupId
)

export const assignPopupMembershipIdsSelector = createSelector(
  assignPopupSelector,
  ({ membershipIds }) => membershipIds
)

export const assignPopupInvitationIdsSelector = createSelector(
  assignPopupSelector,
  ({ invitationIds }) => invitationIds
)

export const assignPopupGroupIdsSelector = createSelector(
  assignPopupSelector,
  ({ groupIds }) => groupIds
)

export const membershipsWithSlugConflictSelector = createSelector(
  assignPopupSelector,
  ({ membershipsWithSlugConflict }) => membershipsWithSlugConflict
)

const unassignPopupSelector = createSelector(
  assignSelector,
  ({ unassignPopup }) => unassignPopup
)

export const isUnassignPopupOpenSelector = createSelector(
  unassignPopupSelector,
  ({ isOpen }) => isOpen
)

export const isUnassignPopupSubmittingSelector = createSelector(
  unassignPopupSelector,
  ({ submitting }) => submitting
)

export const unassignPopupMembershipIdSelector = createSelector(
  unassignPopupSelector,
  ({ membershipId }) => membershipId
)

export const unassignPopupOwnerTypeSelector = createSelector(
  unassignPopupSelector,
  ({ owner }) => owner
)

const membershipsSelector = createSelector(assignSelector, (slice) => slice.memberships)

export const userGroupMembershipsSelector = createSelector(membershipsSelector, (memberships) => memberships.groups.entities)
